import { LockedScheduleInfo } from "../components/schedule-item"
import { IsLockedToolTip } from "./is-locked-tool-tip"

LockedScheduleInfo.plug(<IsLockedToolTip if={({ lockData }) => lockData.isLocked || lockData.inCurrentProject} />)
